import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

function Navigation({ children, className = '' }) {
  return (
    <div className={`step-controllers ${className}`.trim()}>
      {children}
    </div>
  );
}

Navigation.propTypes = propTypes;

export default Navigation;

// Copyright © 2025 Micruity Inc.
